import uuidv4 from 'uuid/v4';

const ADD_NOTIFICATION = 'client-next/globalNotify/ADD_NOTIFICATION';
const REMOVE_NOTIFICATION = 'client-next/globalNotify/REMOVE_NOTIFICATION';
const CLEAR_NOTIFICATIONS = 'client-next/globalNotify/CLEAR_NOTIFICATIONS';

const initialState = {
  notifications: [],
};

function globalNotificationsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };
    case REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          notification => notification.uid !== action.payload.uid
        ),
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      };

    default:
      return state;
  }
}

function addNotification(message, type, dataTestName) {
  return {
    type: ADD_NOTIFICATION,
    payload: {
      uid: uuidv4(),
      dataTestName: dataTestName,
      message,
      type,
    },
  };
}

function removeNotification(uid) {
  return {
    type: REMOVE_NOTIFICATION,
    payload: { uid },
  };
}

function clearNotifications() {
  return {
    type: CLEAR_NOTIFICATIONS,
  };
}

const actions = {
  addNotification,
  clearNotifications,
  removeNotification,
};

export { actions };
export default globalNotificationsReducer;



// WEBPACK FOOTER //
// ./src/portfolio-shared/state/reducers/globalNotificationsReducer.js